<script setup>
import { getUsername, useStore } from "@/components/Utils/functions";
import apiCall from "@/utils/api";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { computed, getCurrentInstance } from "vue";

const { proxy } = getCurrentInstance();

const props = defineProps({
  role: {
    type: Object,
  },
  dialogOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:dialogOpen"]);

const store = useStore();

const deleteRoleMtn = useMutation({
  mutationFn: async () => {
    await apiCall({
      url: `/api/role/${props.role.id}`,
      method: "DELETE",
    });
  },
});

const innerDialogOpen = computed({
  get() {
    return props.dialogOpen;
  },
  set(newVal) {
    emit("update:dialogOpen", newVal);
  },
});

const queryClient = useQueryClient();
const deletePermission = async () => {
  try {
    await deleteRoleMtn.mutateAsync();
    queryClient.invalidateQueries({
      queryKey: ["listRoles"],
    });
    store.commit("openSnackbar", {
      open: true,
      text: proxy.$t("roleDeletedMsg"),
      color: "success",
    });
  } catch (e) {
    console.log(e);
    store.commit("openSnackbar", {
      open: true,
      text: e.response.data?.detail,
      color: "error",
      timeout: 8000
    });
  } finally {
    innerDialogOpen.value = false;
  }
};
</script>

<template>
  <v-dialog v-model="innerDialogOpen" max-width="800px" :persistent="deleteRoleMtn.isLoading.value">
    <v-card class="py-1 px-2">
      <v-card-title class="justify-space-between">
        <span class="primary--text font-weight-bold">{{
          $t("deleteRoleMsg")
        }}</span>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              @click="innerDialogOpen = false"
              v-on="on"
              v-bind="attrs"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="text-body-1">
        {{ $t("deleteRoleConfirmationMsg", { msg: role.name }) }}
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          depressed
          color="error"
          class="text-none"
          :loading="deleteRoleMtn.isLoading.value"
          @click="deletePermission"
          >{{ $t("archiveMsg") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
